
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import { H1, H3 } from 'library/atoms/Typography';
import styled from '@emotion/styled';
import Icon from 'shared/library/atoms/Icon';
import Text from 'library/atoms/Typography/Text';
import CoverImage from 'library/atoms/CoverImage/CoverImage';
import Flex from 'shared/library/atoms/Flex/Flex';
const firstCoverBackgroundImage = 'https://res.cloudinary.com/eola/image/upload/v1636035105/localhost/public_images/style-guide-home-page-cover-1.jpg';
const secondCoverBackgroundImage = 'https://res.cloudinary.com/eola/image/upload/v1636035234/localhost/public_images/style-guide-home-page-cover-2.jpg';
const thirdCoverBackgroundImage = 'https://res.cloudinary.com/eola/image/upload/v1636035487/localhost/public_images/style-guide-home-page-cover-3.jpg';
const principleRows = [
    [
        { primaryText: 1, secondaryText: 'Everything is a component' },
        {
            primaryText: 2,
            secondaryText: "Aim for total style encapsulation; don't rely on inheritance to provide default styles."
        }
    ],
    [
        {
            primaryText: 3,
            secondaryText: 'Build small building blocks with minimal props to keep complexity low.'
        },
        {
            primaryText: 4,
            secondaryText: 'Keep system constrained by only including props needed per component.'
        }
    ],
    [
        {
            primaryText: 5,
            secondaryText: 'Favor wrapping or extending components for more complex operations.'
        },
        {
            primaryText: 6,
            secondaryText: 'Maintain design system consistency with utilities as props (for spacing, color, font-size, line-height, widths, and radii).'
        }
    ]
];
const StyleGuideHomePage = () => {
    return (<StyledWrapper>
      <StyledHeaderImage>
        <H1>eola Style Guide</H1>
      </StyledHeaderImage>
      <StyledPrincipals>
        <Flex alignItems="center" mt={4}>
          <Icon name="react" color="primary" size={24} mr={2}/>
          <Text fontStyle="p2" color="tertiary">
            This style guide is a React implementation of {`eola's`} design
            system
          </Text>
        </Flex>
        <H3 my={4}>Principles</H3>
        <StyledPrincipalsRow>
          <StyledBoxContainer>
            {principleRows[0].map(item => (<StyledBox key={`${item.primaryText}`}>
                <Text fontStyle="h3" as="div">
                  {item.primaryText}
                </Text>
                <Text color="secondary" fontStyle="h5">
                  {item.secondaryText}
                </Text>
              </StyledBox>))}
          </StyledBoxContainer>
          <StyledFlex>
            <StyledCoverImage src={firstCoverBackgroundImage}/>
          </StyledFlex>
        </StyledPrincipalsRow>

        <StyledPrincipalsRow>
          <StyledFlex>
            <StyledCoverImage src={secondCoverBackgroundImage}/>
          </StyledFlex>

          <StyledBoxContainer>
            {principleRows[1].map(item => (<StyledBox key={`${item.primaryText}`}>
                <Text fontStyle="h3" as="div">
                  {item.primaryText}
                </Text>

                <Text color="secondary" fontStyle="h5">
                  {item.secondaryText}
                </Text>
              </StyledBox>))}
          </StyledBoxContainer>
        </StyledPrincipalsRow>

        <StyledPrincipalsRow>
          <StyledBoxContainer>
            {principleRows[2].map(item => (<StyledBox key={`${item.primaryText}`}>
                <Text fontStyle="h3" as="div">
                  {item.primaryText}
                </Text>

                <Text color="secondary" fontStyle="h5">
                  {item.secondaryText}
                </Text>
              </StyledBox>))}
          </StyledBoxContainer>

          <StyledFlex>
            <StyledCoverImage src={thirdCoverBackgroundImage}/>
          </StyledFlex>
        </StyledPrincipalsRow>

        <StyledInfoBar>
          This style guide is meant to show only the common variations, please
          check the component file to see all the options and full details.
        </StyledInfoBar>
      </StyledPrincipals>
    </StyledWrapper>);
};
export default StyleGuideHomePage;
const StyledWrapper = styled.div(({ theme }) => ({
    marginBottom: theme.space[8]
}));
const StyledHeaderImage = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 224,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url("https://res.cloudinary.com/eola/image/upload/v1635147414/eola/public_images/style-guide-home-page-header.jpg")`,
    backgroundPosition: 'center',
    h1: {
        color: theme.colors.white,
        textAlign: 'center'
    }
}));
const StyledPrincipals = styled.div(({ theme }) => ({
    marginRight: theme.space[4],
    marginLeft: theme.space[4],
    [theme.mediaQueries.xxl]: {
        marginRight: theme.space[10],
        marginLeft: theme.space[10]
    }
}));
const StyledBox = styled.div(({ theme }) => ({
    backgroundColor: theme.colors.white,
    padding: theme.space[5],
    marginRight: theme.space[2],
    marginLeft: theme.space[2],
    flex: 1,
    marginBottom: theme.space[4],
    borderRadius: theme.space[2],
    div: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: theme.space[7],
        height: theme.space[7],
        backgroundColor: theme.colors.background.secondary,
        color: theme.colors.primary,
        borderRadius: theme.space[2],
        marginBottom: theme.space[3]
    },
    [theme.mediaQueries.md]: {
        height: 320
    },
    [theme.mediaQueries.sm]: {
        height: 240
    },
    [theme.mediaQueries.xs]: {
        height: 'auto'
    }
}));
const StyledPrincipalsRow = styled.div(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    [theme.mediaQueries.xs]: {
        flexDirection: 'column'
    },
    [theme.mediaQueries.xl]: {
        flexDirection: 'row'
    }
}));
const StyledCoverImage = styled(CoverImage)(({ theme }) => ({
    flex: 1,
    marginBottom: theme.space[4],
    [theme.mediaQueries.md]: {
        height: 320
    },
    [theme.mediaQueries.sm]: {
        height: 240
    },
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
}));
const StyledBoxContainer = styled.div(({ theme }) => ({
    display: 'flex',
    flex: 1,
    [theme.mediaQueries.md]: {},
    [theme.mediaQueries.xs]: {
        flexDirection: 'column'
    },
    [theme.mediaQueries.sm]: {
        flexDirection: 'row'
    }
}));
const StyledFlex = styled.div(({ theme }) => ({
    flex: 1,
    marginRight: theme.space[2],
    marginLeft: theme.space[2],
    [theme.mediaQueries.xs]: {
        order: 3
    },
    [theme.mediaQueries.xl]: {
        order: 'initial'
    }
}));
const StyledInfoBar = styled.div(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    minHeight: 48,
    color: theme.colors.eola.greys[70],
    backgroundColor: theme.colors.background.secondary,
    borderRadius: theme.radii[2],
    border: 'none',
    padding: theme.mixins.pxSpread([theme.space[4], theme.space[3]]),
    textAlign: 'left',
    ...theme.fontStyle.p3
}));

    async function __Next_Translate__getStaticProps__197303e4e32__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'shared/library//StyleGuide/StyleGuideHomePage',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197303e4e32__ as getStaticProps }
  